import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GenericLegendDialogComponent } from '../../generic-legend-dialog/generic-legend-dialog.component';

@Component({
  selector: 'aw-test-card',
  templateUrl: './test-card.component.html',
  styleUrls: ['./test-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TestCardComponent {

  @Input() test;
  @Output() ifaceChipEvent = new EventEmitter<string>();
  @Output() uneceChipEvent = new EventEmitter<string>();
  showLegend = false;
  
  constructor(public dialog: MatDialog){}

  panelOpenState = false;

  REG_ID = /^(?<content>.*?)(?=\s*\((?<id>(?:slt\.\d+|gb-\d+(?:\.\d+)+|red\.[a-z]+-\d+(?:-\d+)*))\))/i;

  // extractSLT(text: string): string | null {
  //   const match = text.match(/\((slt.\d+)\)/);
  //   return match ? match[1] : null;
  // }

  extractRegulationId(text: string): string | null {
    return this.REG_ID.exec(text)?.groups?.id ?? null;
  }

  extractTextRegulation(text: string): string {
    return this.REG_ID.exec(text)?.groups?.content ?? null;
  }

  checkCIA(element, letter: string): boolean {
    return element.cia.some(item => item[0].toLowerCase() === letter.toLowerCase());
  }
  getCIAArray() {
    return Array.from('CIA');
  }

  getSTRIDEArray() {
    return Array.from('STRIDE');
  }
  checkSTRIDE(element, letter: string): boolean {
    return element.stride.some(item => item[0].toLowerCase() === letter.toLowerCase());
  }

  getCIATooltip(element): string {
    const mappings = {
      'C': 'Confidentiality',
      'I': 'Integrity',
      'A': 'Availability'
    };

    return Object.keys(mappings).map(letter =>
      `${this.checkCIA(element, letter) ? '✓' : 'X'} ${mappings[letter]}`
    ).join('\n');

  }

  getSTRIDETooltip(element): string {
    const mappings = {
      'S': 'Spoofing',
      'T': 'Tampering',
      'R': 'Repudiation',
      'I': 'Information Disclosure',
      'D': 'Denial of Service',
      'E': 'Elevation of Privilege'
    };

    return Object.keys(mappings).map(letter =>
      `${this.checkSTRIDE(element, letter) ? '✓' : 'X'} ${mappings[letter]}`
    ).join('\n');
  }

  onIfaceChipClick(event: MouseEvent, variation: string) {
    event.stopPropagation();
    this.ifaceChipEvent.emit(variation);
  }

  onUneceChipClick(event: MouseEvent, variation: string) {
    event.stopPropagation();
    this.uneceChipEvent.emit(variation);
  }

  openLegend(event: Event) {
    event.stopPropagation();
    this.dialog.open(GenericLegendDialogComponent, {
      data: {
        title: "Test Legend",
        legend: [
          {color: "#b2a47f", text: "List of vulnerability or attack method related to the threats - UNECE R155 - Annex 5"},
          {color: "#dbb7a3", text: "List of vulnerability or attack method related to the threats GB"},
          {color: "#F6CECE", text: "List of vulnerability or attack method related to the threats RED"},
          {color: "#d7d7d7", text: "Test target related to attack surfaces or protocols"},
          {color: "red", text: "STRIDE & CIA threat model classification"}
        ]
      }
    })
  }

}
